import { enumLabel, hasMessage, t, type MessageKey } from '@ctcells/i18n'

import { statusKind } from '../../atoms/statusKind.ts'

/**
 * 모듈 상태의 **굵은 표기** — 관리 › 모듈 표의 「상태」 열이 쓴다.
 *
 * eric 2026-09-23 「여기서 상태를 디테일한 걸로 하지 말고 대기 · 진행 이런 식으로.. 수시로 바뀌게 하지 마」.
 * 염색기가 `MOVING → PIPETTING → DISPENSING → …` 로 스트림마다 배지를 갈아 껴 표가 깜빡였다.
 *
 * 🔴 **분류를 여기서 발명하지 않는다.** 정본 `06 §4.2a` 6분류를 옮긴 `statusKind()` 가 접고, 여기는
 *    그 분류에 한글 한 벌(`enum.moduleStateKind.*`)을 붙일 뿐이다. 그래서 세부 동작은 전부 「진행」이고,
 *    **사람을 부르는 `WAITING_FOR_MANUAL_TRAY_LOAD` · `WAITING_FOR_MANUAL_TRAY_UNLOAD` 는 「개입 대기」로 남는다**
 *    (로봇 회수 대기 `WAITING_FOR_TRAY_UNLOAD` 는 사람 할 일이 없어 「진행」 · `06 §4.2a`) —
 *    그걸 「진행」으로 접으면 사람이 가야 하는 순간이 표에서 사라진다.
 * 🔴 **모르는 원값은 원값 그대로**(`enumLabel` 규약) — `statusKind()` 는 모르는 값을 `idle` 로 떨어뜨리는데
 *    그걸 「대기」로 적으면 「사전이 뚫렸다」는 경보가 「멈춘 장비」로 둔갑한다. 사전에 있는 값만 접는다.
 * ⚠ 세부 표기(`enum.moduleState.*`)는 그대로 산다 — 모듈 상세와 배지 툴팁(`coarseModuleStateDetail`)이 쓴다.
 */
export function coarseModuleStateLabel(state: string): string {
  if (!hasMessage(`enum.moduleState.${state}`)) return enumLabel('enum.moduleState', state)
  return t(`enum.moduleStateKind.${statusKind(state)}` as MessageKey)
}

/**
 * 배지 툴팁에 넣을 세부 표기. 굵은 표기와 **같으면 `undefined`** — 「대기」 위에 「대기」 툴팁은 소음이다.
 */
export function coarseModuleStateDetail(state: string): string | undefined {
  const detail = enumLabel('enum.moduleState', state)
  return detail === coarseModuleStateLabel(state) ? undefined : detail
}
